import { storageAvailable } from './storage-bridge.js';
import { cloudAvailable } from './cloud-auth.js';

/* Qué se puede añadir y en qué grupo sale en el asistente «Añadir fuente». Cada grupo responde a «¿dónde están los vídeos?». */

export const SOURCE_GROUPS = [
    { id: 'device', icon: 'smartphone', types: ['local'] },
    { id: 'network', icon: 'lan', types: ['smb', 'files', 'jellyfin', 'emby', 'plex'] },
    { id: 'cloud', icon: 'cloud', types: ['dropbox', 'onedrive'] },
    { id: 'tv', icon: 'live_tv', types: ['free', 'm3u', 'xtream'] }
];

/** Cómo se reparten los grupos en la primera pantalla del asistente. */
export const SECTIONS = [
    { id: 'videos', groups: ['device', 'network', 'cloud'] },
    { id: 'tv', groups: ['tv'] }
];

/** «¿No sabes cuál elegir?»: situaciones de la vida real y a dónde llevan (un tipo concreto, o la lista de tipos de un grupo). */
export const HELP = [
    { id: 'device', group: 'device', type: 'local' },
    { id: 'nas', group: 'network', type: 'smb' },
    { id: 'server', group: 'network' },
    { id: 'cloud', group: 'cloud' },
    { id: 'free', group: 'tv', type: 'free' },
    { id: 'list', group: 'tv', types: ['xtream', 'm3u'] }
];

/** Las situaciones que se pueden resolver en este aparato (con lo que de verdad hay disponible). */
export function helpOptions(opts) {
    return HELP.filter((h) => {
        const here = availableTypes(h.group, opts);
        if (h.type) return here.indexOf(h.type) !== -1;
        if (h.types) return h.types.some((x) => here.indexOf(x) !== -1);
        return here.length > 0;
    });
}

/** Los que no se escriben en una pantalla propia del asistente: abren el formulario de siempre ya con el tipo elegido. */
export const CLASSIC_TYPES = ['files', 'jellyfin', 'emby', 'plex', 'free', 'm3u', 'xtream'];

/** Las que se conectan iniciando sesión en el servicio. */
export const CLOUD_TYPES = ['dropbox', 'onedrive'];

export const isClassic = (type) => CLASSIC_TYPES.indexOf(type) !== -1;

/**
 * Tipos que se pueden elegir ahora mismo. SMB y las carpetas del aparato necesitan la parte nativa de la app (no existen en la web);
 * la televisión por listas (Xtream, M3U) solo se ofrece cuando ya hay alguna fuente: la primera pantalla empieza por lo sencillo.
 */
export function availableTypes(group, { hasProviders = true, native = storageAvailable, cloud = (type) => cloudAvailable(type, { native }) } = {}) {
    const g = SOURCE_GROUPS.find((x) => x.id === group);
    if (!g) return [];
    return g.types.filter((type) => {
        if (type === 'smb' || type === 'local') return native(type);
        if (type === 'dropbox' || type === 'onedrive') return cloud(type); // hace falta la clave de la app y el servidor local nativo
        if ((type === 'm3u' || type === 'xtream') && !hasProviders) return false;
        return true;
    });
}

/** Grupos con algo que elegir. */
export function availableGroups(opts) {
    return SOURCE_GROUPS.filter((g) => availableTypes(g.id, opts).length > 0);
}
